import { render, staticRenderFns } from "./AdminSchedulesModalSendMessage.vue?vue&type=template&id=023a32b1&scoped=true"
import script from "./AdminSchedulesModalSendMessage.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesModalSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a32b1",
  null
  
)

export default component.exports